module.exports = __webpack_public_path__ + "fonts/osp-din-webfont.e24b386b.ttf";